import axios from "axios";
import { notEmptyString, isNumeric, emptyString } from "./helpers"
import config from "../config/config";
import { validDateString } from "./validators";

const buildOptions = (isFormData, formData, callback) => {
  const { apiKey, httpAuth } = config;
  let options = {}
  let headers = {};
  if (apiKey) {
    if (apiKey.length > 1) {
      headers.apikey = config.apiKey
    }
  }
  if (httpAuth) {
    if (httpAuth.user && httpAuth.pass) {
      if (httpAuth.user.length > 3 && httpAuth.pass.length > 3) {
        const credentials = btoa(httpAuth.user + ":" + httpAuth.pass);
        headers.Authorization = "Basic " + credentials;
      }
    }
  }
  if (isFormData) {
    headers['X-Requested-With'] = 'XMLHttpRequest';
    headers['Content-Type'] = 'multipart/form-data';
    if (callback instanceof Function) {
      options.onUploadProgress = callback;
    }
  }
  options.headers = headers;
  return options;
}

const postData = async (path, params, callback, putMode) => {
  let result = {}
  const isFormData = params instanceof FormData;
  let func = putMode !== true ? axios.post : axios.put;
  await func(`${config.backendApi}${path}`, params, buildOptions(isFormData, params, callback)).then(res => {
    result = res
  }).catch(e => {
    console.log(e)
  })
  return result
}

const putData = async (path, params, callback) => {
  return postData(path, params, callback, true);
}

const fetchData = async (path, deleteMode) => {
  let result = {}
  let func = deleteMode !== true ? axios.get : axios.delete
  await func(`${config.backendApi}${path}`, buildOptions()).then(res => {
    result = res
  }).catch(e => {
    console.log(e)
  })
  return result
}

const fetchContent = async (path) => {
  return fetchData(path, false)
}

const buildQueryString = (criteria) => {
  let str = "";
  if (criteria instanceof Object) {
    let parts = [];
    Object.entries(criteria).forEach(entry => {
      parts.push(entry[0] + "=" + encodeURIComponent(entry[1]));
    });
    if (parts.length > 0) {
      str = '?' + parts.join('&');
    }
  }
  return str;
}

export const getData = async path => {
  let data = { valid: false };
  await fetchContent(path).then(response => {
    if (response.data) {
      data = response.data;
      data.valid = true;
    }
  });
  return data;
}

export const listSubmissions = async (start = 0, limit = 100, criteria) => {
  let data = {
    valid: false
  }
  if (limit !== 100) {
    limit = parseInt(limit)
  }
  if (start !== 0) {
    start = parseInt(start)
  }
  let filteredCriteria = {};
  if (criteria instanceof Object) {

    Object.entries(criteria).forEach(et => {
      const [k, v] = et;
      switch (k) {
        case 'status':
          if (notEmptyString(v, 2)) {
            filteredCriteria[v] = 1;
          }
          break;
        default:
          filteredCriteria[k] = v;
          break;
      }
    })
  }
  const cKey = "submission/list/" + start + "/" + limit + buildQueryString(filteredCriteria);
  await fetchContent(cKey).then(res => {
    if (res.data) {
      if (res.data.items instanceof Array) {
        data = res.data
      }
    }
  })
  return data
}

export const listSlides = async (stage, media, uid = 0) => {
  let data = {
    valid: false
  }
  if (!stage) {
    stage = 'submitted';
  }
  if (!media) {
    media = 'all';
  }
  let uidParam = "";
  if (isNumeric(uid)) {
    uid = parseInt(uid);
    if (uid > 0) {
      uidParam = "/" + uid;
    }
  }
  const cKey = "submission/slides/" + stage + "/" + media + uidParam;
  await fetchContent(cKey).then(res => {
    if (res.data) {
      if (res.data.slides instanceof Array) {
        data = res.data
        data.valid = true;
      }
    }
  })
  return data
}


export const getTotals = async () => {
  let data = {
    valid: 0
  }
  const cKey = "submission/totals";
  await fetchContent(cKey).then(res => {
    if (res.data) {
      if (res.data.valid) {
        data = res.data
      }
    }
  })
  return data
}

export const getOverview = async (isEditor = false) => {
  let data = {
    valid: 0
  }
  const parts = ['submission', 'slides-overview'];
  if (!isEditor) {
    parts.push('review');
  }
  const cKey = parts.join('/');
  await fetchContent(cKey).then(res => {
    if (res.data) {
      if (res.data.valid) {
        data = res.data;
      }
    }
  })
  return data
}

export const listUsers = async (start = 0, limit = 100, criteria) => {
  let output = {};
  await fetchContent('user/list/' + start + '/' + limit + buildQueryString(criteria))
    .then(res => {
      if (res.data) {
        output = res.data;
        output.valid = true;
      }
    });
  return output;
}

export const listAdmins = async () => {
  return listUsers(0, 1000, { editor: 1, admin: 1 });
}

export const listSignUp = async () => {
  const path = 'user/signup-list';
  const output = { items: [], valid: false };
  await fetchContent(path)
    .then(res => {
      if (res instanceof Object) {
        const { data } = res;
        if (data instanceof Object) {
          if (data.items instanceof Array) {
            output.items = data.items;
            output.valid = data.valid;
          }
        }
      }
    });
  return output;
}

export const listSignUpCsv = async () => {
  const path = 'user/signup-list-csv';
  let output = { valid: false };
  await fetchContent(path)
    .then(res => {
      if (res instanceof Object) {
        const { data } = res;
        if (data.valid) {
          output = data;
        }
      }
    });
  return output;
}

export const bulkEdit = async (data) => {
  let output = { valid: false };
  await postData('submission/bulk-edit', data).then(res => {
    if (res.data) {
      output = res.data;
      output.valid = true;
    }
  });
  return output;
}

const deleteData = async path => {
  return fetchData(path, true)
}

export const fetchSiteData = async () => {
  let data = {
    valid: false,
  }
  const cKey = "setting/options";
  await fetchContent(cKey).then(res => {
    if (res.data.options) {
      if (res.data.options instanceof Array) {
        data = res.data
      }
    }
  })
  return data
}


export const getDataList = async (cKey, mapFunc) => {
  let dataList = [];
  if (!mapFunc) {
    mapFunc = item => item;
  }
  await fetchContent(cKey).then(res => {
    if (res.data) {
      if (res.data instanceof Array) {
        dataList = res.data.map(mapFunc);
      }
    }
  })
  return dataList;
}

export const getDataItems = async (cKey, mapFunc) => {
  const items = await getDataList(cKey, mapFunc);
  const num = items.length;
  return {
    items,
    valid: num > 0,
    num
  }
}

export const authenticate = async (email, password) => {
  let data = {
    valid: false,
    hasSubmission: false
  }
  let params = {
    email,
    password
  }
  await postData("user/login", params).then(response => {
    if (response.data) {
      const user = response.data
      if (user.identifier) {
        if (user.active) {
          Object.entries(user).forEach(entry => {
            const [key, val] = entry;
            data[key] = val;
          });
          data.valid = true
        }
      }
      if (user.msg) {
        data.msg = user.msg
      }
    }
  })
  return data
}

export const updateUser = async (userId, edited) => {
  let data = {
    valid: false
  }
  await putData("user/edit/" + userId, edited).then(response => {
    if (response.data) {
      const { user, msg } = response.data
      if (user instanceof Object && notEmptyString(user._id, 12)) {
        data.user = user;
        data.valid = true;
      }
      if (msg) {
        data.msg = msg
      }
    }
  })
  return data
}

export const resetPassword = async (hash, params) => {
  let data = {
    valid: false,
    msg: "unmatched"
  }
  await putData(`user/reset-pass/` + hash, params).then(res => {
    if (res.data) {
      if (res.data.identifier) {
        data = res.data
        if (data.valid) {
          data.msg = "OK"
        } else {
          data.msg = "Account unavailable"
        }
      }
    }
  })
  return data
}

export const requestReset = async email => {
  let data = {
    valid: false,
    msg: "unmatched"
  }
  await postData(`user/reset-request`, { email }).then(res => {
    if (res.data) {
      if (res.data instanceof Object) {
        data = res.data
        if (data.link) {
          data.valid = true;
        }
      }
    }
  })
  return data
}

export const registerUser = async (params) => {
  let data = {
    valid: false,
    user: null,
    msg: ""
  }
  const saveParams = {
    identifier: params.identifier,
    firstName: params.firstName,
    lastName: params.lastName,
    password: params.password,
    mode: "local",
    role: params.role,
    active: params.active
  };
  await postData(`user/create`, saveParams).then(res => {
    if (res.data) {
      if (res.data.user) {
        const { user } = res.data;
        data.msg = res.data.message;
        if (user._id) {
          data.user = user;
          data.valid = true;
        }
      }
    }
  })
  return data
}

const handleSubmissionResponse = (response, data) => {
  if (response.data) {
    const { submission, message } = response.data
    if (submission instanceof Object) {
      if (submission._id) {
        data.submission = submission;
        data.valid = true;
      }
    }
    if (message) {
      data.msg = message;
    }
  }
}

export const getResetUser = async (hash) => {
  const response = await fetchContent('user/reset/' + hash);
  let data = {
    valid: false
  }
  if (response) {
    if (response.data) {
      data = response.data;
    }
  }
  return data;
}

export const saveSubmission = async (edited) => {
  let data = {
    valid: false,
    submission: null
  }
  if (edited.user) {
    if (emptyString(edited.college)) {
      delete edited.college;
    }
    if (edited.endYear) {
      if (!validDateString(edited.endYear)) {
        delete edited.endYear;
      }
    }
    if (edited.startYear) {
      if (!validDateString(edited.startYear)) {
        delete edited.startYear;
      }
    }
    if (edited._id) {
      await putData("submission/edit/" + edited._id, edited).then(response => handleSubmissionResponse(response, data));
    } else {
      await postData("submission/create", edited).then(response => handleSubmissionResponse(response, data));
    }
  }

  return data
}

export const reviewSubmission = async (submissionID, attribute, newVal, workID) => {
  let data = {
    valid: false,
    submission: null
  }
  let edited = {};
  let hasData = false;
  if (notEmptyString(attribute, 2)) {
    hasData = true;
    edited[attribute] = newVal;
    if (notEmptyString(workID, 5)) {
      edited.workID = workID;
    }
  }
  if (hasData) {
    await putData("submission/edit-review/" + submissionID, edited).then(response => handleSubmissionResponse(response, data));
  }
  return data;
}

export const registerPayment = async (submissionId, transactionRef) => {
  const response = await putData('submission/register-payment/' + submissionId, { transactionRef });
  let data = {
    valid: false
  }
  if (response.data) {
    const { submission } = response.data;
    if (submission instanceof Object) {
      data.submission = submission;
      data.valid = submission._id.length > 3 && submission.feePaid;
    }
  }
  return data;
}

export const saveWork = async (submissionId, edited) => {
  let data = {
    valid: false,
    work: null,
    msg: ''
  }
  let isNew = true;
  if (edited._id) {
    isNew = edited._id.length <= 3;
  }
  if (edited instanceof Object) {
    const verb = isNew ? 'add-work' : "edit-work";
    let path = "submission/" + verb + "/" + submissionId;
    if (!isNew) {
      path += "/" + edited._id;
    }
    await putData(path, edited).then(response => {

      if (response.data) {
        const { work, message } = response.data;
        if (work) {
          data.work = work;
          data.valid = work instanceof Object;
        }
        data.msg = message;
      }
    });
  }
  return data
}


/* const filterVimeoData = (fileInfo) => {
  let data = {};
  Object.entries(fileInfo).forEach(entry => {
    let [key, value] = entry;
    switch (key) {
      case 'width':
      case 'height':
      case 'duration':
        data[key] = value;
        break;
      case 'thumbnail_large':
        data.preview = value;
        break;
      case 'upload_date':
        data.uploadDate = new Date(value);
        break;
    }
  })
  return data;
} */

const filterVimeoData = (fileInfo) => {
  let data = {};
  Object.entries(fileInfo).forEach(entry => {
    let [key, value] = entry;
    switch (key) {
      case 'width':
      case 'height':
      case 'duration':
        data[key] = value;
        break;
      case 'thumbnail_large':
        data.preview = value;
        break;
      case 'upload_date':
        data.uploadDate = new Date(value);
        break;
      case 'created_time':
        data.uploadDate = new Date(value);
        break;
      case 'pictures':
        if (value instanceof Object) {
          const { sizes } = value;
          if (sizes instanceof Array) {
            const thumb = sizes.find(s => s.width >= 640 && s.height < 1024);
            if (thumb instanceof Object) {
              data.preview = thumb.link;
            }
          }
        }
        break;
    }
  });
  return data;
}

export const saveResource = async (submissionId, workId, fileInfo, source) => {
  let data = { valid: false };
  if (!source) {
    source = 'vimeo';
  }
  const mediaItem = {
    source,
    filename: 'vimeo://' + fileInfo.id,
    sourceFilename: fileInfo.url,
    title: fileInfo.title,
    mime: 'video/vimeo',
    type: 'video',
    attributes: filterVimeoData(fileInfo)
  }
  await postData("submission/add-file/" + submissionId + "/" + workId, mediaItem).then(response => {
    if (response.data) {
      data = response.data;
      data.valid = true;
    }
  });
  return data;
}

export const saveFile = async (submissionId, workId, itemId, file, callback) => {
  let data = { valid: false };
  if (submissionId && workId) {
    let formData = new FormData();
    formData.set('file', file);
    const isNew = !notEmptyString(itemId, 5);
    // overide max number of files per submission for administrator
    const maxFiles = isNew ? 20 : 10;
    const itemRef = isNew ? "-" : itemId;
    const url = ['submission/upload', submissionId, workId, itemRef, maxFiles].join('/');
    const response = await postData(url, formData, callback);
    if (response.data) {
      if (response.data.error) {
        data.error = response.data.error;
      } else {
        data = response.data;
      }
    }
  }
  return data;
}

export const saveUpload = async (userId, destination, file, name, callback) => {
  let data = { valid: false };
  if (userId) {
    let formData = new FormData();
    if (file instanceof File) {
      formData.set('file', file);
      let url = 'submission/file/' + userId;
      if (notEmptyString(destination, 2)) {
        url += '/' + destination;
      }
      if (notEmptyString(name, 5)) {
        url += '/' + name;
      }
      const response = await postData(url, formData, callback);
      if (response.data) {
        if (response.data.error) {
          data.error = response.data.error;
        } else {
          data = response.data;
        }
      }
    }
  }
  return data;
}

export const renameDownloadFile = async (userId, sourceName, newName) => {
  let data = { valid: false };
  if (userId) {
    let url = 'submission/rename-file/' + userId;
    if (notEmptyString(sourceName, 2) && notEmptyString(newName, 5)) {
      url += '/' + sourceName + '/' + newName;
      const response = await fetchData(url);
      if (response.data) {
        if (response.data.error) {
          data.error = response.data.error;
        } else {
          data = response.data;
        }
      }
    }
  }
  return data;
}

export const deleteDownloadFile = async (userId, sourceName) => {
  let data = { valid: false };
  if (notEmptyString(userId, 2) && notEmptyString(sourceName, 2)) {
    let url = 'submission/remove-file/' + userId + '/' + sourceName;
    const response = await deleteData(url);
    if (response.data) {
      if (response.data.error) {
        data.error = response.data.error;
      } else {
        data = response.data;
      }
    }
  }
  return data;
}

export const editMediaItem = async (submissionId, workId, item) => {
  const { _id } = item;
  const uri = ['submission', 'edit-file', submissionId, workId, _id].join('/');
  let edited = {};
  if (item.filename.indexOf('vimeo') === 0) {
    item.source = 'vimeo';
  }
  Object.entries(item).forEach(entry => {
    const [k, v] = entry;
    switch (k) {
      case '_id':
        break;
      default:
        edited[k] = v;
        break;
    }
  })
  const response = await putData(uri, edited);
  if (response.data) {
    return response.data;
  } else {
    return {
      valid: false
    }
  }
}

export const getRemoteSubmission = async (submissionId) => {
  const cKey = "submission/item/" + submissionId;
  let data = {
    valid: false
  };
  await fetchContent(cKey).then(res => {
    if (res.data) {
      if (res.data._id) {
        data = res.data
        data.valid = true;
      }
    }
  })
  return data;
}

export const getSnippets = async () => {
  return await getDataItems("snippet/list");
}

export const saveSnippet = async (snippetId, params) => {
  const cKey = "snippet/edit/" + snippetId;
  let data = {
    valid: false
  };
  await putData(cKey, params).then(res => {
    if (res.data) {
      if (res.data) {
        if (res.data.snippet) {
          data = res.data;
          data.valid = true;
        }
      }
    }
  })
  return data;
}

export const getMessages = async () => {
  return await getDataItems("message/list");
}

export const saveMessage = async (messageId, params) => {
  const cKey = "message/edit/" + messageId;
  let data = {
    valid: false
  };
  await putData(cKey, params).then(res => {
    if (res.data) {
      if (res.data.message) {
        data = res.data.message;
        data.valid = true;
      }
    }
  })
  return data;
}

export const bulkSaveSnippets = async snippets => {
  const cKey = "snippet/bulk-save";
  let data = {
    valid: false
  };
  if (snippets instanceof Array) {
    await postData(cKey, { items: snippets }).then(res => {
      if (res.data) {
        if (res.data.result) {
          data = res.data.result;
          data.valid = true;
        }
      }
    })
  }
  return data;
}

export const addSnippet = async (params) => {
  const cKey = "snippet/create";
  let data = {
    valid: false
  };
  await postData(cKey, params).then(res => {
    if (res.data) {
      if (res.data.snippet) {
        data = res.data.snippet;
        data.valid = true;
      }
    }
  })
  return data;
}

export const getSettings = async () => {
  return await getDataItems("setting/list");
}

export const saveSetting = async (settingId, params) => {
  const cKey = "setting/edit/" + settingId;
  let data = {
    valid: false
  };
  await putData(cKey, params).then(res => {
    if (res.data) {
      if (res.data.setting) {
        data = res.data.setting;
        data.valid = true;
      }
    }
  })
  return data;
}

export const saveCollege = async (collegeId, params) => {
  const cKey = "college/edit/" + collegeId;
  let data = {
    valid: false
  };
  await putData(cKey, params).then(res => {
    if (res.data) {
      if (res.data.college) {
        data = res.data.college;
        data.valid = true;
      }
    }
  })
  return data;
}

export const addCollege = async (params) => {
  const cKey = "college/create";
  let data = {
    valid: false
  };
  await postData(cKey, params).then(res => {
    if (res.data) {
      if (res.data.college) {
        data = res.data.college;
        data.valid = true;
      }
    }
  })
  return data;
}

export const getQuestions = async () => {
  return await getDataItems("question/list");
}

export const saveQuestion = async (questionId, params) => {
  const cKey = "question/edit/" + questionId;
  let data = {
    valid: false
  };
  await putData(cKey, params).then(res => {
    if (res.data) {
      if (res.data.question) {
        data = res.data.question;
        data.valid = true;
      }
    }
  })
  return data;
}

export const addQuestion = async (params) => {
  const cKey = "question/create";
  let data = {
    valid: false
  };
  await postData(cKey, params).then(res => {
    if (res.data) {
      if (res.data.question) {
        data = res.data.question;
        data.valid = true;
      }
    }
  })
  return data;
}

export const sortQuestions = async items => {
  let data = {
    valid: false
  };
  if (items instanceof Array) {
    await postData("question/save-order", items).then(res => {
      if (res.data.questions) {
        data = res.data.question;
        data.valid = true;
      }
    });
  }
  return data;
}

export const deleteQuestion = async (id) => {
  const cKey = "question/delete/" + id;
  let data = {
    valid: false
  };
  await deleteData(cKey).then(res => {
    if (res.data) {
      if (res.data) {
        data = res.data;
        data.valid = true;
      }
    }
  })
  return data;
}

export const removeMediaItem = async (submissionId, workId, itemId) => {
  const uri = ['submission', 'remove-file', submissionId, workId, itemId].join('/');
  const response = await putData(uri, { id: itemId });
  if (response.data) {
    return response.data;
  } else {
    return {
      valid: false
    }
  }
}

export const removeWork = async (submissionId, workId) => {
  const uri = ['submission', 'remove-work', submissionId, workId].join('/');
  const response = await putData(uri);
  if (response.data) {
    return response.data;
  } else {
    return {
      valid: false
    }
  }
}

export const generatePdf = async (submissionId, userId) => {
  let data = {
    valid: false
  };
  if (notEmptyString(submissionId, 5) && notEmptyString(userId, 5)) {
    const res = await fetchContent('submission/create-pdf/' + submissionId + '/' + userId);
    if (res.data) {
      if (res.data.valid) {
        data.valid = true;
      }
    }
  }
  return data;
}

export const matchPdfPath = async userId => {
  let data = {
    valid: false,
    path: '',
  };
  if (notEmptyString(userId, 5)) {
    const res = await fetchContent('submission/pdf-path/' + userId);
    if (res.data) {
      if (res.data.path) {
        data = res.data;
        data.valid = data.path.length > 5;
      }
    }
  }
  return data;
}

export const activateAccount = async key => {
  let data = {
    valid: false
  }
  let params = {
    activationCode: key
  }
  await postData("activate", params).then(res => {
    if (res.data) {
      data = res.data
      data.profile = {}
    }
  })
  return data
}


export const getCountries = async () => {
  const mapFunc = c => {
    return {
      id: c.code2L,
      label: c.name
    }
  }
  return await getDataList("country/list", mapFunc);
}

export const getColleges = async () => {
  const mapFunc = c => {
    return {
      id: c._id,
      label: c.fullName
    }
  }
  return await getDataList("college/colleges", mapFunc);
}

export const listColleges = async () => {
  return await getDataList("college/colleges");
}

export const getResponses = async (start = 0, limit = 100) => {
  return await getDataList("response/list/" + start + '/' + limit);
}

export const getSurveyStats = async () => {
  let data = { valid: false };
  const response = await fetchData("response/stats");
  if (response.data) {
    data = response.data;
    if (data.questions) {
      data.valid = data.questions instanceof Array;
    }
  }
  return data;
}

export const fetchResponse = async (submissionId, questions) => {
  let data = {
    submissionId: '',
    responses: []
  }
  await fetchContent('response/fetch/' + submissionId).then(response => {
    if (response.data) {
      const { submission, answers } = response.data;
      if (submission === submissionId && answers instanceof Array) {
        const responses = answers.map(a => {
          const qn = questions.find(q => q._id === a.question);
          let value = a.value;
          let altValue = null;
          switch (qn.type) {
            case 'select_other':
              if (qn.options.findIndex(op => {
                let valid = op.key === a.value;
                if (!valid) {
                  valid = op.text.toLowerCase() == a.value.toLowerCase();
                }
                return valid;
              }) < 0) {
                value = 'other';
                altValue = a.value;
              }
              break;
          }
          return {
            key: qn.key,
            value,
            altValue
          }
        })
        data.responses = responses;
        data.submissionId = submission;
      }
    }
  });
  return data;
}

export const getMailLog = async (format = 'json', limit = 100) => {
  let data = {
    valid: false,
    lines: []
  }
  await fetchContent("message/log/" + + limit + '/' + format).then(res => {
    if (res.data) {
      if (res.data.lines instanceof Array) {
        data = res.data;
        data.valid = true;
      }
    }
  })
  return data;
}

export const getMailList = async () => {
  let data = {
    valid: false,
    numMails: 0,
    recipients: []
  }
  await fetchContent("submission/mail/overview").then(res => {
    if (res.data) {
      if (res.data.recipients instanceof Array) {
        data = res.data;
        data.valid = true;
      }
    }
  })
  return data;
}

export const getMailsByEmail = async (email) => {
  let data = {
    valid: false,
    num: 0,
    mails: []
  }
  await fetchContent("submission/mail/" + email).then(res => {
    if (res.data) {
      if (res.data.mails instanceof Array) {
        data = res.data;
        data.valid = true;
      }
    }
  })
  return data;
}

export const bulkMail = async (key, userId, mode) => {
  if (!mode) {
    mode = "test";
  }
  if (!userId) {
    userId = "";
  }
  let data = {
    valid: false,
    sent: 0,
    msg: 'Could not send emails',
    emails: [],
    testMode: false
  }
  await fetchContent("submission/send-mails/" + key + "/" + userId + "/" + mode).then(res => {
    if (res.data instanceof Object) {
      if (res.data.valid) {
        data = res.data;
        data.valid = true;
      }
    }
  })
  return data;
}

export const exportCollection = async (collectionName, format) => {
  let data = { valid: false };
  const response = await fetchContent('setting/export/' + collectionName + '/' + format);
  if (response.data) {
    data = response.data;
    data.valid = true;
  }
  return data;
}

export const readDirectory = async (directoryName) => {
  let data = { valid: false };
  const response = await fetchContent('setting/list-dir/' + directoryName);
  if (response.data) {
    data = response.data;
    data.valid = true;
  }
  return data;
}


/* export const getVimeoData = async (mediaId) => {
  const url = "https://vimeo.com/api/v2/video/" + mediaId + ".json";
  let data = {
    valid: false
  }
  await axios.get(url).then(res => {
    if (res.data) {
      if (res.data instanceof Array && res.data.length > 0) {
        const item = res.data[0];
        if (item instanceof Object) {
          if (item.url) {
            data = item;
            data.source = 'vimeo';
            data.valid = true
          }
        }
      }
    }
  })
  return data;
} */


export const getVideoInfo = async (uri = '') => {
  const videoId = notEmptyString(uri, 5) ? uri.split('/').pop() : '';
  const response = await fetchContent('submission/check-vimeo-id/' + videoId);
  const { data } = response;
  if (data instanceof Object) {
    const { info } = data;
    if (info instanceof Object) {
      return { valid: true, ...info };
    }
  } else {
    return { valid: false };
  }
}

export const getVimeoData = async (mediaId = '') => {
  const url = "https://vimeo.com/api/v2/video/" + mediaId + ".json";
  let data = {
    valid: false
  }
  await axios.get(url).then(res => {
    if (res.data) {
      if (res.data instanceof Array && res.data.length > 0) {
        const item = res.data[0];
        if (item instanceof Object) {
          if (item.url) {
            data = item;
            data.source = 'vimeo';
            data.valid = true;
          }
        }
      }
    } else {
      data.notAvailable = true;
    }
  }).catch(e => {
    if (e) {
      data.notAvailable = true;
    }
  })
  if (!data.valid) {
    const info = await getVideoInfo(mediaId);
    if (info instanceof Object && info.valid) {
      data = info;
      if (!data.id) {
        if (info.link) {
          data.id = info.link.split('.com/').pop();
        } else if (info.uri) {
          data.id = info.uri.split('/').pop();
        }
        if (notEmptyString(info.name)) {
          data.title = info.name;
        }
      }
    }
  }
  return data;
}